import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'appSearchPipe' })
export class SearchPipe implements PipeTransform {
  transform(items: any[], searchText: string, field: string = ""): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    if (field) {
      return items.filter(it => {
        if (it) {
          return it[field]?.toLowerCase().includes(searchText);
        }
      });
    }

    return items.filter(it => {
      if (it) {
        return JSON.stringify(it).toLowerCase().includes(searchText);
      }
    });
  }
}
